export default "__VITE_ASSET__BhIhD9Zg__"